import { GetServerSidePropsContext } from 'next';

import { PageCategory } from '~/features/analytics/constants';
import { ErrorContentSection } from '~/features/errors/components/error-content-section';
import { ErrorContent } from '~/features/errors/types/error-content';
import { getCustomErrorContent } from '~/features/errors/utils/get-custom-error-content';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { Page } from '~/features/page/models/page';
import { getInternalPage } from '~/features/page/utils/get-internal-page';

export default function CustomErrorPage({ errorContent, page }: { page: Page; errorContent: ErrorContent }) {
  return (
    <>
      <PageHead page={page} pageCategory={PageCategory.Uncategorized} />
      <PageLayout withoutVerticalPadding>
        <ErrorContentSection {...errorContent} />
      </PageLayout>
    </>
  );
}

export async function getServerSideProps({ query }: GetServerSidePropsContext) {
  const page = getInternalPage({ eventName: 'Viewed Error Page' });

  return {
    props: {
      errorContent: getCustomErrorContent(query),
      page,
    },
  };
}
